var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:`${this.name}__${this.keyName}`,domProps:{"textContent":_vm._s(_vm.count)}})
}
var staticRenderFns = []

export { render, staticRenderFns }